import Button from '@pelckmans/elementis/components/button';
import ButtonGroup from '@pelckmans/elementis/components/button-group';
import List from '@pelckmans/elementis/components/list';
import Pill from '@pelckmans/elementis/components/pill';
import WarningIcon from '@pelckmans/elementis/icons/warning';
import BrandIcon from '../../../shared-components/BrandIcon';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AccountContext from '../../../contexts/AccountContext';
import IdentityContext from '../../../contexts/IdentityContext';
import { buildGroupProps } from '../../../utils/elementisUtils';
import useLoginProvider from '../hooks/useLoginProvider';

export default function PelckmansIdentity() {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const {
    identity: { fullName },
  } = useContext(IdentityContext);
  const {
    account: { primaryEmail, verifiedEmail, existingPassword },
  } = useContext(AccountContext);

  const { completeIdentity } = useLoginProvider();

  function handleComplete() {
    if (!primaryEmail || !verifiedEmail) {
      return completeIdentity('set-email', language);
    }

    if (!existingPassword) {
      return completeIdentity('set-password', language);
    }

    return completeIdentity('complete', language);
  }

  const getSubtext = () => {
    if (!verifiedEmail && existingPassword)
      return t('PAGES.PROFILE.MY_DETAILS.LINKED_ACCOUNTS.PELCKMANS_IDENTITY.NOT_VERIFIED');
    if (!verifiedEmail) return t('PAGES.PROFILE.MY_DETAILS.LINKED_ACCOUNTS.PELCKMANS_IDENTITY.NO_EMAIL');

    if (!existingPassword) return t('PAGES.PROFILE.MY_DETAILS.LINKED_ACCOUNTS.PELCKMANS_IDENTITY.NO_PASSWORD');
  };

  const subText = getSubtext();

  return (
    <List.Item
      title={fullName}
      icon={<BrandIcon />}
      subText={subText || primaryEmail}
      contentArea={
        subText ? (
          <Pill role="status" aria-label={subText} icon={<WarningIcon size="sm" />} prominence="warning" size="sm" />
        ) : undefined
      }
      actionArea={
        <ButtonGroup
          {...buildGroupProps(
            <>
              {primaryEmail && verifiedEmail && existingPassword ? (
                <Button prominence="neutral" size="sm" onClick={handleComplete}>
                  {t('PAGES.PROFILE.MY_DETAILS.LINKED_ACCOUNTS.EDIT_PROFILE')}
                </Button>
              ) : (
                <Button prominence="neutral" size="sm" onClick={handleComplete}>
                  {t('PAGES.PROFILE.MY_DETAILS.LINKED_ACCOUNTS.COMPLETE_PROFILE')}
                </Button>
              )}
            </>,
          )}
          size="sm"
        />
      }
    />
  );
}
